import { formatNumberWithSpaces } from "utils/formatNumberWithSpaces";
import { useTranslation } from "react-i18next";
import { Card, Col, Row } from "antd";

const { Meta } = Card;
import { MdOutlinePendingActions } from "react-icons/md";
import CardTitle from "components/CardTitle";
import CardLayout from "components/CardLayout";

interface PendingRevenueProps {
  totalDocuments?: number | string;
  totalValue?: number | string;
  subtotal?: number | string;
  currencyCode: ID;
  decimalPlaces: number;
  loading: boolean;
}

export default function PendingRevenue(props: PendingRevenueProps): React.ReactElement {
  const { currencyCode, totalDocuments, decimalPlaces, totalValue, loading } = props;

  const { t } = useTranslation();

  const formattedTotalValue = formatNumberWithSpaces(
    Number(totalValue ?? 0).toFixed(decimalPlaces),
  );

  return (
    <CardLayout
      className="offer-card"
      loading={loading}
      tooltipText={t("Only validated documents are taken into account")}
      title={<CardTitle icon={<MdOutlinePendingActions />} title={t("Offer in progress")} />}
    >
      <Meta
        description={
          <>
            <Row gutter={[16, 0]} justify="start" className="card-values">
              <Col span={24} className="card-main-value">
                <strong>{totalDocuments}</strong>{" "}
                <span className="tva-type-name">{t("documents")}</span>
              </Col>
              <Col className="card-detail-row">
                <div className="card-detail-item">
                  <span className="card-detail-label">{t("Sub-total")}:</span>
                  <span className="card-detail-value">
                    <strong>
                      {formattedTotalValue} {currencyCode}
                    </strong>
                  </span>
                </div>
              </Col>
            </Row>
          </>
        }
      />
    </CardLayout>
  );
}
